export default __webpack_public_path__ + "static/media/elearning.5a5c4dd1.svg";